import React, { useState } from 'react';


// react-bootstrap components
import { Button, Spinner, Form, Container, Row, Col, Alert } from "react-bootstrap";

import Select from "react-select";

import { useAppState } from "../../../state";




const LightningControllersUtilityPanel = (props) => {
    const debugPeriodOptions = [        
        { value: "oneMin", label: "1 Min" },
        { value: "fiveMin", label: "5 Min" },
        { value: "fifteenMin", label: "15 Min" },
        { value: "thirtyMin", label: "30 Min" },
    ]

    const { user, app, onAppStateRefresh } = useAppState();

    const [selectedDebugPeriodOptions, setSelectedDebugPeriodOptions] = useState(debugPeriodOptions[1]);

    const [debugStarted, setDebugStarted] = useState(false);

    const [errorMessage, setErrorMessage] = useState();

    let errorAlertCotnet;


    const handleStartPlcDebug = async () => {
        try {
            const url = "api/Router/EnablePlcLogging";

            const response = await fetch(url,
                {
                    method: "put",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    }),
                    body: JSON.stringify({ address: props.routerAddress, plcLoggingPeriod: selectedDebugPeriodOptions.value })
                });

            let responseBody = await response.json();  

            if (response.status === 200) {
                if (responseBody.success) {
                    setDebugStarted(true);
                }
                else {
                    setDebugStarted(false);
                    setErrorMessage(responseBody.responseMesssage);
                }
            } else {
                console.log(responseBody);
            }

        } catch (e) {
            console.log(e);
        }
    }

    const handleCancelPlcDebug = () => {
        setDebugStarted(false);
    }

    let startDebugButton;
    if (debugStarted) {
        startDebugButton = (
            <>
                <Button className="mr-1" variant="danger"
                    onClick={handleCancelPlcDebug}>
                    Cancel
                </Button>
                <Button className="mr-1" variant="primary"
                    onClick={handleStartPlcDebug}
                >
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </Button>
            </>
        );
    } else {
        startDebugButton = (
            <Button className="mr-1" variant="primary"
                onClick={handleStartPlcDebug}
            >
                Start
            </Button>
        );
    }

    if (errorMessage) {
        errorAlertCotnet = (
            <Alert key={"danger"} variant={"danger"}>
                {errorMessage}    
            </Alert>
        );
    }

    return (
        <Container fluid>
            <Row>
                <Col>
                    <h4 className="mt-0">Turn on Debug Mode</h4>                    
                    <Alert key={"dark"} variant={"dark"}>
                        The debug mode will send a message to the PLC device to start a debug session based on the chosen period (1 min, 5 min, etc..). Durring the debug session, the log messages will be captured and stored in the cloud analytic service. Then, visit Azure Log Analytics Workspace by clicking this<a target="_blank" rel="noopener noreferrer" href="https://portal.azure.com/#@parexcellence.com/resource/subscriptions/77b78c28-c57d-4023-a932-a43a91daa1f0/resourceGroups/rg-prod-east-us/providers/Microsoft.OperationalInsights/workspaces/log-analytics-prod1/logs">&nbsp;link.&nbsp;</a>Please get in touch with the System Admin if you can't access Log Analytics in the Azure Portal.
                    </Alert>
                    {errorAlertCotnet}
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <Form.Group                      
                    >
                        <label>
                            Debug Period
                        </label>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="debugPeriod"
                            value={selectedDebugPeriodOptions}
                            onChange={(value) => {
                                setSelectedDebugPeriodOptions(value)
                            }
                            }
                            options={debugPeriodOptions}
                            placeholder="Select"
                            isDisabled={debugStarted}
                        />
                        
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-3">
                <Col md="12" className="d-flex">
                    {startDebugButton}
                </Col>
            </Row>
        </Container>
    );
};

export default LightningControllersUtilityPanel;
